import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

// Thunk for fetching country information
export const getCountryStateInformation = createAsyncThunk(
  '/getCountryInfo',
  async (_, { rejectWithValue }) => {
    try {

      const response = await axios.get(ENDPOINTS.LOCATION.GET_COUNTRY);

      return response.data; // Returning response data
    } catch (error) {
      
      console.error("Error occurred in API call:", error);

      // Handle errors gracefully
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching country information."
      );
    }
  }
);

// Initial state of the slice
const initialState = {
  countryData: [], // Holds fetched data
  isLoading: false, // Tracks loading state
  error: null, // Holds error messages
};

// Redux slice
const getCountryInfoSlice = createSlice({
  name: "country",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCountryStateInformation.pending, (state) => {
        state.isLoading = true;
        state.error = null; // Reset errors on new request
      })
      .addCase(getCountryStateInformation.fulfilled, (state, action) => {
        state.countryData = action.payload.data || []; // Assign received data
        state.isLoading = false;
        state.error = null; // Clear error on success
      })
      .addCase(getCountryStateInformation.rejected, (state, action) => {
        console.error("Rejected: Error occurred:", action.payload);
        state.isLoading = false;
        state.error = action.payload; // Assign error message
      });
  },
});

export default getCountryInfoSlice.reducer;
